import axios from "axios";

const capi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/customer`, withCredentials: true });

let refreshing = null;
capi.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !(cfg.url || "").startsWith("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || capi.post("/auth/refresh");
        await refreshing;
      } catch (e) {
        return Promise.reject(err);
      } finally {
        refreshing = null;
      }
      return capi(cfg);
    }
    return Promise.reject(err);
  }
);

export default capi;
